import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Necesito conocimientos técnicos para usar esta guía?',
    a: 'No, todo está diseñado para usuarios sin experiencia técnica.'
  }, {
    q: '¿Cómo personalizo los prompts para mi situación?',
    a: 'Agrega detalles específicos como tus horarios, tipo de negocio o tipo de tareas.'
  }, {
    q: '¿Qué pasa si ChatGPT me da respuestas imprecisas?',
    a: 'Ajusta el prompt con más contexto o pide ejemplos adicionales.'
  }, {
    q: '¿Funciona con otros modelos de IA?',
    a: 'Sí, aunque la guía está optimizada para ChatGPT, muchos prompts se pueden adaptar a otros modelos.'
  }, {
    q: '¿Necesito herramientas pagas para automatizar?',
    a: 'No es obligatorio, se pueden usar herramientas gratuitas como Google Calendar, Notion, etc.'
  }, {
    q: '¿En cuánto tiempo veré resultados?',
    a: 'Desde el primer día que apliques los prompts, notarás mejoras en tu organización y productividad.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section id="faq" className="py-24 px-6 bg-gradient-to-b from-navy-700 to-navy-900 relative" data-id="element-12">
      <div className="max-w-3xl mx-auto" data-id="element-13">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-14">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-15">
            Preguntas Frecuentes
          </h2>
          <div className="w-24 h-1 bg-cyan-neon mx-auto rounded-full" data-id="element-16"></div>
        </motion.div>

        <div className="space-y-4" data-id="element-17">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="bg-cyan-neon/[0.03] border border-cyan-neon/20 rounded-xl overflow-hidden" data-id="element-18">
                <button onClick={() => toggleFaq(i)} aria-expanded={isOpen} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-cyan-neon" data-id="element-19">
                  <span className="text-lg font-bold text-cyan-neon pr-4" data-id="element-20">
                    {faq.q}
                  </span>
                  <motion.div animate={{
                rotate: isOpen ? 180 : 0
              }} transition={{
                duration: 0.3
              }} className="shrink-0" data-id="element-21">
                    <ChevronDownIcon className="w-6 h-6 text-cyan-neon" data-id="element-22" />
                  </motion.div>
                </button>

                <AnimatePresence initial={false} data-id="element-23">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-24">
                      <div className="px-6 pb-5 text-slate-300 leading-relaxed" data-id="element-25">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}